var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{attrs:{"width":_vm.isCollapse ? '70px' : '240px'}},[_c('asideBar')],1),_c('el-main',[_c('mainBar',{attrs:{"current-route":_vm.$route}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }